import { render } from "./ExpandButton.vue?vue&type=template&id=11342794&scoped=true&ts=true"
import script from "./ExpandButton.vue?vue&type=script&lang=ts"
export * from "./ExpandButton.vue?vue&type=script&lang=ts"

import "./ExpandButton.vue?vue&type=style&index=0&id=11342794&scoped=true&lang=scss"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11342794"]])

export default __exports__